<template>
<div id="container">
<div id="header" style="width:1200px">
<h2 style="margin-bottom:0;">广州虎牙信息科技有限公司</h2></div>
<div id="menu" style="height:550px;width:480px;float:left;">
</div>
<div style="height:300px;width:1500px;text-align:left;">
<tr>&#12288;&#12288;广州虎牙信息科技有限公司成立于2017年6月，是虎牙直播的技术开发中心。参与制定基于了边缘计算节点服务标准，在基于该标准的高清多人连麦、AI美颜、云游戏、5G+4K高清移动直播等技术方面都是行业领先。</tr>
<tr>&#12288;&#12288;随着5G时代的到来和AI技术的发展，虎牙在技术开放、虚实结合、生态优化等方向发力，推出虚实结合开放平台HERO、直播技术公共服务平台、小程序开放平台、AI内容审核平台等对外开放平台，开启直播技术普惠之路。提高了数字创意产业内容创作的技术竞争力，降低了内容生产的门槛，优化了产业生态环境。 </tr>       
<tr>&#12288;&#12288;对外合作上面，在AI数字人上已经与腾讯有合作，构建虚拟人物形象，同时开放了HERO数字人技术平台；与华为签署了战略合作协议，成立“联合创新中心”，立足5G+Cloud+X直播新业务场景的研究与落地，协同打造更加繁荣的内容生态；联合华为云发布了“昇腾AI内容审核”解决方案，基于昇腾全栈创新的能力，加强违规内容的审核与过滤，为绿色互联网环境保驾护航。虎牙也是5G云游戏产业联盟(5GCGA)理事单位，通过与通信领域、游戏领域等产业链上下游企业合作，探索5G与AI等前沿技术在直播行业的具体运用。</tr></div>

<div style="height:50px;width:180px;float:left;"><img src="../assets/1.png"></div>
<div style="height:50px;width:180px;float:left;"><img src="../assets/2.png"></div>
<div style="height:50px;width:180px;float:left;"><img src="../assets/3.png"></div>
<div style="height:50px;width:240px;float:left;"><img src="../assets/4.png"></div>
<div style="height:50px;width:240px;float:left;"><img src="../assets/5.png"></div>

<div style="background-color:#888888 ;clear:both;text-align:center;height:40px;">
<p><a href="http://beian.miit.gov.cn/" target="_blank">粤ICP备2021054394号 </a>
<font color="white"> 广州虎牙信息科技有限公司  版权所有© 2021 </font></p></div>

</div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue